import React, { Component } from 'react';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter, FormGroup, Label, Input, Col } from 'reactstrap';
import './TotalCss.css'
import './FetchData.css';
import { api_url } from "./globalFunction/global_string";
import Swal from 'sweetalert2';
import { SelectNet } from "./BasicComponents/SelectNet";
import { SelectUnitproxyApply } from "./BasicComponents/SelectUnitproxyApply";
import { SelectUnit } from "./BasicComponents/SelectUnit";

const userTypeMapping = {
  "超級管理員": "S",
  "區網管理員": "M",
  "單位使用者": "N",
  "無權限訪客": "G"
};

export class FetchDataDomainTable extends Component {
  static displayName = FetchDataDomainTable.name;

  constructor(props) {
    super(props);
    this.state = {
      fetchDataForDomainTable: props.fetchDataForDomainTable,
      isFetchDatDomainTable: props.isFetchDataDomainTable,
      selectnet: '',
      selectedUnitproxy: '',
      selectedUnit: '',
      selectuser_type: '',
      forecasts: [],
      loading: true,
      columnSort: { url_addr: 'asc', unit_name: 'asc', build_id: 'asc', build_date: 'asc' },
      userTypeOptions: ["超級管理員", "區網管理員", "單位使用者", "無權限訪客"],
      modal: false,
      editingItem: null,
    };
  }


  componentDidMount() {
    this.populateWeatherData();

  }

  componentDidUpdate(prevProps, prevState) {

    if (prevState.selectnet !== this.state.selectnet ||
      prevState.selectedUnitproxy !== this.state.selectedUnitproxy ||
      prevState.selectedUnit !== this.state.selectedUnit ||
      prevState.selectuser_type !== this.state.selectuser_type) {
      this.populateWeatherData();
    }
  }
  openRegisterModal = (forecast) => {
    //console.log(forecast)
    this.setState({
      modal: true,
      editingItem: forecast,
      selectedUserName: forecast.user_name,
      domain: forecast.domain,
      selectedUserId: forecast.user_id
    });
  };

  closeRegisterModal = () => {
    this.setState({ modal: false, editingItem: null });
  };


  saveChanges = () => {
    const Domain = JSON.stringify(this.state.domain);
    const formData = new FormData();
    formData.append('currentUserId', this.props.fetchedData.user_id);
    formData.append('user_name', this.state.selectedUserName);
    formData.append('user_id', this.state.selectedUserId);
    formData.append('domain', Domain);
    fetch(api_url + '/api/Async/PutUserDomain', {
      method: 'POST',
      headers: {
        "Authorization": localStorage.getItem('accessToken'),
      },
      body: formData,
    })
      .then(response => response.json()) // 提取 JSON 数据
      .then(result => {
        if (result.statusCode === 200) {
          Swal.fire({
            icon: 'success',
            title: '【修改成功】',
            text: '恭喜'
          });
          this.closeRegisterModal();
          this.populateWeatherData();
        } else {
          Swal.fire({
            icon: 'error',
            title: `${result.detail}`,
            text: '更新失敗'
          });
          console.error('更新失敗:', result);
        }
      })
      .catch(error => {
        Swal.fire({
          icon: 'error',
          title: '【出錯了】',
          text: '無法完成請求'
        });
        console.log('Error fetching JSON:', error);
      });
  };

  // 處理網域選擇
  handleNetSelectChange = (data) => {
    const { value, selectedName } = data;
    this.setState((prevState) => ({
      selectnet: value,
      local_net_name: selectedName,
      selectedUnitproxy: '',  // 清空單位
      local_unit_proxy_name: '',  // 清空單位名稱
      formData: {
        ...prevState.formData,
        excel_unit_url: '',  // 清空網址
      }
    }), () => {
      // console.log("Selected net updated:", this.state.selectnet, this.state.local_net_name);
    });
  };

  SelectUnitproxyApply = (data) => {
    const { value, selectedName } = data;
    this.setState({ selectedUnitproxy: value, local_unit_proxy_name: selectedName }, () => {
      // console.log("Selected unit updated:", this.state.selectedUnitproxy, this.state.local_unit_proxy_name);
    });
  };
  // 處理單位選擇變更事件
  handleUnitSelectChange = (data) => {
    // console.log(data);
    const { value, selectedName } = data;

    this.setState(prevState => ({
      selectedUnit: value,
      local_unit_name: selectedName,
    }), () => {
      //.log("Selected unit updated:", this.state.selectedUnit, this.state.local_unit_name);
    });
  };
  handleUserTypeSelectChange = (event) => {
    this.setState({ selectuser_type: event.target.value });
  };

  renderTableHeader() {
    return (
      <thead>
        <tr>
          <th className='nancy_table_width10'>
            <div className="nancy-table-topC">操作</div></th>
          <th className='nancy_table_width15'>
            <div className="nancy-table-top">使用者區網名稱</div></th>
          <th className='nancy_table_width20'>
            <div className="nancy-table-top">使用者單位名稱</div></th>
          <th className='nancy_table_width15'>
            <div className="nancy-table-top">使用者帳號</div></th>
          <th className='nancy_table_width15'>
            <div className="nancy-table-topC">使用者名稱</div></th>
          <th className='nancy_table_width60'>
            <div className="nancy-table-top">使用者網域資料</div></th>
        </tr>
      </thead>
    );
  }

  renderTableBody(forecasts) {
    //console.log("render:", forecasts);
    return (
      <tbody>
        {forecasts.map(forecast => {
          return (
            <tr key={forecast.id}>
              <td>
                <Button type="modify" className="mx-1 d-inline" onClick={() => this.openRegisterModal(forecast)}>修改</Button>
              </td>
              <td>{forecast.local_net_name}</td>
              <td>{forecast.local_unit_name}</td>
              <td>{forecast.user_id}</td>
              <td>{forecast.user_name}</td>
              <td className="word-wrap">{forecast.domain}</td>
            </tr>
          )
        })}
      </tbody>
    );
  }

  render() {
    const userType = localStorage.getItem('login_user_type');
    const net_name = localStorage.getItem('login_user_net_name');
    let FormDataUsertype;
    let contents = this.state.loading
      ? <p><em>Loading...</em></p>
      : this.renderTableBody(this.state.forecasts);

    if (userType === 'S') {
      FormDataUsertype = (
        <div id="site_manage" className="row col-12 mb-5 justify-content-center">
          <FormGroup row className="col-12 col-md-10 col-lg-8">
            <Label for="local_net_id" sm={2}>區網名稱</Label>
            <Col sm={6}>
              <SelectNet
                parentName={'superS'}
                id={'excel_net_name'}
                name={'excel_net_name'}
                requiredAPI={'/api/JRCC/GetLocalNetId'}
                handleNetSelectChange={this.handleNetSelectChange}
              />
            </Col>
          </FormGroup>
          <FormGroup row className="col-12 col-md-10 col-lg-8">
            <Label for="excel_unit_proxy_name" sm={2}>單位名稱</Label>
            <Col sm={6}>
              <SelectUnitproxyApply
                parentName={'superS'}
                id={'excel_unit_proxy_name'}
                name={'excel_unit_proxy_name'}
                requiredAPI={'/api/Async/GetNetDownUnitlist'}
                SelectUnitproxyApply={this.SelectUnitproxyApply}
                selectnet={this.state.selectnet}
                local_net_name={this.state.local_net_name}
              />
            </Col>
          </FormGroup>
          <FormGroup row className="col-12 col-md-10 col-lg-8">
            <Label for="userTypeSelect" sm={2}>使用者權限</Label>
            <Col sm={6}>
              <select
                id="userTypeSelect"
                value={this.state.selectuser_type}
                onChange={this.handleUserTypeSelectChange}
                className="form-select"
              >
                <option value="">請選擇</option>
                {this.state.userTypeOptions.map(option => (
                  <option key={option} value={userTypeMapping[option]}>{option}</option>
                ))}
              </select>
            </Col>
          </FormGroup>
        </div>
      );
    } else if (userType === 'M') {
      FormDataUsertype = (
        <div id="site_manage" className="row col-12 mb-5 justify-content-center">
          <FormGroup row className="col-12 col-md-10 col-lg-8">
            <Label sm={2}>區網名稱</Label>
            <Col sm={6}>
              <span className="form-control-plaintext">{net_name}</span>
            </Col>
          </FormGroup>
          <FormGroup row className="col-12 col-md-10 col-lg-8">
            <Label for="excel_unit_proxy_name" sm={2}>單位名稱</Label>
            <Col sm={6}>
              <SelectUnit
                parentName={'Excel'}
                id={'excel_unit_name'}
                name={'excel_unit_name'}
                requiredAPI={'/api/JRCC/GetLocalUnitId'}
                onUnitSelectChange={this.SelectUnitproxyApply}
              />
            </Col>
          </FormGroup>
          <FormGroup row className="col-12 col-md-10 col-lg-8">
            <Label for="userTypeSelect" sm={2}>使用者權限</Label>
            <Col sm={6}>
              <select
                id="userTypeSelect"
                value={this.state.selectuser_type}
                onChange={this.handleUserTypeSelectChange}
                className="form-select"
              >
                <option value="">請選擇</option>
                {this.state.userTypeOptions.map(option => (
                  <option key={option} value={userTypeMapping[option]}>{option}</option>
                ))}
              </select>
            </Col>
          </FormGroup>
        </div>

      );
    }
    return (
      <div className='mt-2'>
        {FormDataUsertype}
        <table id='tablelabel' className='table table-striped table-bordered dt-responsive nowrap vertical-align-center' aria-labelledby="tableLabel">
          {this.renderTableHeader()}
          {contents}
        </table>
        <Modal isOpen={this.state.modal} toggle={this.closeRegisterModal}>
          <ModalHeader toggle={this.closeRegisterModal}>修改資料</ModalHeader>
          <ModalBody>
            <FormGroup>
              <Label for="userName">使用者名稱</Label>
              <Input type="text" id="userName" value={this.state.selectedUserName} onChange={e => this.setState({ selectedUserName: e.target.value })} />
            </FormGroup>
            <FormGroup>
              <Label for="domain">使用者網域資料</Label>
              <Input type="textarea" id="domain" value={this.state.domain} onChange={e => this.setState({ domain: e.target.value.trim() })} rows="5" style={{ resize: 'vertical' }} />
            </FormGroup>
          </ModalBody>
          <ModalFooter>
            <Button color="primary" onClick={this.saveChanges}>儲存</Button>{' '}
            <Button color="secondary" onClick={this.closeRegisterModal}>取消</Button>
          </ModalFooter>
        </Modal>
      </div>
    );
  }

  async populateWeatherData() {
    const { selectnet, selectedUnitproxy, selectedUnit, selectuser_type } = this.state;

    const formData = new FormData();
    formData.append("user_type", this.props.fetchedData.user_type);
    if (this.props.fetchedData.user_type === 'M') {
      formData.append("local_net_id", this.props.fetchedData.local_net_id);
    }
    if (this.state.user_type === 'M') {
      formData.append("local_unit_id", selectedUnit);
    } else {
      if (selectedUnitproxy) {
        formData.append("local_unit_id", selectedUnitproxy);
      }
    }
    if (selectuser_type) {
      formData.append("selectedUserType", selectuser_type);
    }

    await fetch(this.props.fetchedData.apiUrl, {
      method: "POST",
      headers: { "Authorization": localStorage.getItem('accessToken') },
      body: formData
    })
      .then(response => response.json())
      .then(data => {
        //console.log(data);
        let combinedForecasts = {};
        data.row.forEach(item => {
          if (combinedForecasts[item.user_id]) {
            combinedForecasts[item.user_id].domain += `,${item.domain}`;
          } else {
            combinedForecasts[item.user_id] = {
              user_id: item.user_id,
              user_name: item.user_name,
              domain: item.domain,
              local_net_name: item.local_net_name, // Assuming you have this data
              local_unit_name: item.local_unit_name // Assuming you have this data
            };
          }
        });

        let forecasts = Object.values(combinedForecasts);
        this.setState({ forecasts: forecasts, loading: false });
      })
      .catch(error => {
        console.log('Error fetching JSON:', error);
      });
  }


}
